/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmProfilVlastnostiObsah extends GContentBase<SeznamAdmProfilVlastnostiObsahObj> {
        private seznamObj: SeznamAdmProfilVlastnostiObsahObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmProfilVlastnostiObsahObj());
            var columnOrder = "k_v,{0}ixs_stv_txt,kod_form,priz_pov,dat_zmena,zmenu_provedl";
            var ixsProTxt = "";
            if (this.seznamObj.tabOpen == undefined || this.seznamObj.tabOpen == null)
                ixsProTxt = "ixs_pro_txt,";
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmProfilVlastnostiObsahNew",
                contentCaption: "jres:33000461", //RC 33000457 : Hodnoty vlastnost�
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_pro_txt} - {ixs_stv_txt}"
                },
                gridSettings: {
                    columnOrder: columnOrder.format(ixsProTxt)
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmProfilVlastnostiObsahObj extends GAdmSeznamBase {
        private ixs_pro: string;

        create() {

        }

        updateGridFormat(gridFormat: Gordic.Data.GridFormat<any>) {
            var columnType = new Gordic.Data.GridFormat().addTextColumn({
                name: "type",
                caption: "jres:33000553",
                cellTemplate: (row) => {
                    if (row.ixs_stv) {
                        if (row.ixs_stv != "") {
                            var type = row.ixs_stv.substring(4, 7);
                            if (type == "00V") 
                                return "jres:29932128"
                            else (type == "00S") 
                                return "jres:29931622"
                        }
                    }
                    return "";
                }
            }).columns;
            gridFormat.columns.splice(1, 0, columnType[0]);
            return gridFormat;
        }

        openDetail(data: any, isNew: boolean) {
            // Otev�r�n� p�es cel� okno
            //$.content().navigate(["Gordic.Adm.WebControls.DetailAdmProfilVlastnostiObsah", {
            //    currentFilter: this.filterData,
            //    gridRc: new Gordic.Components.GridRC(this.grid)
            //}], {
            //    ID: "DetailAdmProfilVlastnostiObsah",
            //    newRecord: isNew,
            //    ixs_pro: isNew == true ? (this.ixs_pro ? this.ixs_pro : null) : data.ixs_pro,
            //    ixs_stv: isNew == true ? null : data.ixs_stv
            //})

            // Otev�r�n� p�es mod�ln� okno
            $.content().dialogs.showModalWindow(["Gordic.Adm.WebControls.DetailAdmProfilVlastnostiObsah", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmProfilVlastnostiObsah",
                newRecord: isNew,
                ixs_pro: isNew == true ? (this.ixs_pro ? this.ixs_pro : null) : data.ixs_pro,
                ixs_stv: isNew == true ? null : data.ixs_stv
            },{
                height: 800,
                width: 800
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                {
                    action: this.cnt.actions.actOpenDetail,
                    caption: "jres:33000560", //RC 33000560 : Editovat vazbu
                    favorite: true
                },
                {
                    action: this.cnt.actions.actNewDetail,
                    caption: "jres:33000552", //RC 33000552 : Nov� vazba
                    favorite: true
                },
                "actAddToComparison*"
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                {
                    action: this.cnt.actions.actOpenDetail,
                    caption: "jres:33000560", //RC 33000560 : Editovat vazbu
                    favorite: true
                }
            ])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:29932128").addField("gselectbox", Gordic.Prefabs.Select.ginspro(), {
                dropdown: true,
                model: "model.ixs_pro=value.ixs_pro",
                name: "ixs_pro",
                disabled: (this.ixs_pro) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_pro)
                hardFilter["ixs_pro"] = this.ixs_pro;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_pro)
                data["ixs_pro"] = this.ixs_pro;
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmProfilVlastnostiObsah.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenDetailVlastnostStruktura?.update({ enabled: objArr.count == 1 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#".format(data.ixs_pro, data.ixs_stv),
                nazev: "{0} - {1}".format(data["ixs_pro_txt"], data["ixs_pro_txt"])
            }
        }
    }
}
